var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "Team Content View" } },
            [
              _vm.isShowFilter
                ? _c(
                    "el-select",
                    {
                      staticClass: "select",
                      attrs: {
                        placeholder: "Please select TeamName",
                        filterable: "",
                      },
                      on: { change: _vm.getTableDataInit },
                      model: {
                        value: _vm.teamId,
                        callback: function ($$v) {
                          _vm.teamId = $$v
                        },
                        expression: "teamId",
                      },
                    },
                    _vm._l(_vm.options, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: { label: item.teamName, value: item.teamId },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                staticClass: "select",
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-document-copy" },
                  on: {
                    click: function ($event) {
                      return _vm.copyHandler()
                    },
                  },
                },
                [_vm._v(" Copy Content ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: {
                "sort-change": _vm.onSortChange,
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "45", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MslName",
                  label: _vm.nameLabel,
                  sortable: "custom",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TeamName",
                  label: "TeamName",
                  sortable: "custom",
                  width: "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "FileName",
                  label: "Content Name",
                  sortable: "custom",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: row.AttachmentPath,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(row.FileName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CategoryName",
                  label: "Category",
                  sortable: "custom",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "LevelName",
                  label: "Security Level",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "CreatedOn",
                  label: "Create Date",
                  sortable: "custom",
                  "filter-multiple": "",
                  formatter: _vm.rowDateFormatter,
                  "min-width": "135",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoPush",
                  label: "No.Push",
                  sortable: "custom",
                  "min-width": "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "UvIsRead",
                  label: "UV.Is Read",
                  sortable: "custom",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "RateOfHits",
                  label: "Rate of hits",
                  sortable: "custom",
                  "min-width": "130",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoDownloads",
                  label: "No.Downloads",
                  sortable: "custom",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "UvDuration",
                  label: "UV.Duration(s)",
                  sortable: "custom",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ViewTeamPaperContentDialog", {
        attrs: { visible: _vm.dialogPaperVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.dialogPaperVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("ViewTeamMeetingContentDialog", {
        attrs: { visible: _vm.dialogMeetingVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.dialogMeetingVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("ViewTeamUploadContentDialog", {
        attrs: { visible: _vm.dialogUploadVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.dialogUploadVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }